export function getObjectWithLowestValue(arr, paramName) {
    if (!arr || arr.length === 0) {
        return null; // Handle empty array case
    }

    let minValue = Infinity;
    let minObj = null;

    for (const obj of arr) {
        if (obj.hasOwnProperty(paramName) && typeof obj[paramName] === 'number') {
            if (obj[paramName] < minValue) {
                minValue = obj[paramName];
                minObj = {...obj};
            }
        }
    }

    return minObj;
}